module.exports = __webpack_public_path__ + "img/side_nuestro-equipo2.3dbc6918.png";